/** RESPONSIBILITY: string shaping. No validation, no formatting of values. */

export const isBlank = (v: unknown): boolean =>
  v === null || v === undefined || (typeof v === 'string' && v.trim() === '');

export const trimAll = <T extends Record<string, unknown>>(o: T): T =>
  Object.fromEntries(
    Object.entries(o).map(([k, v]) => [k, typeof v === 'string' ? v.trim() : v]),
  ) as T;

/** Safe for a URL path or a folder name. */
export const slug = (s: string): string =>
  s.toLowerCase().replace(/[^a-z0-9-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 64);

export const truncate = (s: string, n: number): string =>
  (s.length <= n ? s : `${s.slice(0, n - 1)}…`);

export const titleCase = (s: string): string =>
  s.replace(/(^|[\s-_])(\w)/g, (_, a, b: string) => a + b.toUpperCase());

/**
 * Property name → human label. `blueDeep` → "Blue Deep", `give_label` → "Give Label".
 * Used when an annotation omits `label`, so the field name is the default.
 */
export const humanize = (key: string): string =>
  key
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')      // camelCase → camel Case
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')   // URLValue  → URL Value
    .replace(/[_-]+/g, ' ')
    .trim()
    .replace(/^./, (c) => c.toUpperCase());
